import { getUserAgent } from './get-user-agent';
export function isSafari(userAgent) {
    if (userAgent === void 0) { userAgent = ''; }
    var ua = getUserAgent(userAgent).toLowerCase();
    var fd = function (ss) { return ua.indexOf(ss) > -1; };
    var nf = function (ss) { return ua.indexOf(ss) === -1; };
    var a = fd('safari/');
    var b = nf('chrome/');
    var c = nf('qq/') && nf('mqqbrowser');
    return a && b && c;
}
